interface Config {
  env: string;
  apiUrl: string;
  clientUrl: string;
  sentryAuthToken: string;
}

const dev: Config = {
  env: import.meta.env.VITE_NODE_ENV,
  apiUrl: import.meta.env.VITE_DEV_API_URL,
  clientUrl: import.meta.env.VITE_DEV_CLIENT_URL,
  sentryAuthToken: "",
};

const prod: Config = {
  env: import.meta.env.VITE_NODE_ENV,
  apiUrl: import.meta.env.VITE_PROD_API_URL,
  clientUrl: import.meta.env.VITE_PROD_CLIENT_URL,
  sentryAuthToken: import.meta.env.VITE_PROD_SENTRY_AUTH_TOKEN,
};

let config: Config;
if (import.meta.env.VITE_NODE_ENV === "production") {
  config = prod;
} else {
  config = dev;
}

export default config;
